<template>
  <div class="external-panel-container">
    <ExternalEventInfo
      :cast-name="castName"
      :quantity="quantity"
      :cast-image="castImage"
      :open-time="openTime"
      :close-time="closeTime"
      :part="part"
      :is-linked="isLinked"
    />
  </div>
</template>

<script>
import ExternalEventInfo from '~/components/molcules/ExternalEventInfo'

export default {
  components: {
    ExternalEventInfo
  },
  props: {
    castName: {
      type: String,
      default: ''
    },
    quantity: {
      type: Number,
      default: undefined
    },
    castImage: {
      type: String,
      default: undefined
    },
    openTime: {
      type: String,
      default: undefined
    },
    closeTime: {
      type: String,
      default: undefined
    },
    part: {
      type: String,
      default: undefined
    },
    isLinked: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.panel-container {
  border: 2px solid #47b4e6;
  border-radius: 5px;
  padding: 16px 24px;
}
</style>
